<template>
    <div class="edit-container">
        <Message :message="message" :type="type" v-if="message!==''"></Message>
        <UserAccount :title="title" :user="user" @cancel="handleCancel" @save="handleSave" @setMessage="setMessage"
                     form-mode="editUser" v-if="loaded"></UserAccount>
        <Preloader v-else></Preloader>
    </div>
</template>

<script>
import UserAccount from '@/components/UserAccount.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message.vue';
import Preloader from '@/components/helpers/Preloader';

const UserRepository = RepositoryFactory.get('users');

export default {
  name: 'EditUser',
  components: { Preloader, UserAccount, Message },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: this.$t('editUser'),
      message: '',
      type: '',
      loaded: true,
    };
  },
  methods: {
    handleSave(user) {
      this.loaded = false;
      const { token } = this.$store.getters;
      UserRepository.editUser(user, token).then(() => {
        this.$router.push('/administration/users');
      }).catch((e) => {
        this.message = this.$t('errors.genericError');
        this.type = 'error';
      });
    },
    handleCancel() {
      this.$router.push('/administration/users');
    },
    setMessage(message) {
      this.message = message.message;
      this.type = message.type;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-container {
    width: 100%;
}
</style>
